module.exports = __webpack_public_path__ + "img/price.22b1c6f7.svg";